import { BookAppointmentProvider } from '@/components/modules/modals/BookAppointment/BookAppointment.hooks';
import DealDetails from '@/features/deals/pages/DealDetails/DealDetails';
import withDealsFeatureFlag from '@/features/deals/withDealsFeatureFlag';

const DealDetailsPage = () => {
  return (
    <BookAppointmentProvider>
      <DealDetails />
    </BookAppointmentProvider>
  );
};

export default withDealsFeatureFlag(DealDetailsPage);
